<div class="selection-notification"
    [class.opened]="selectionNotificationExpanded"
    [@expansion]="selectionNotificationExpanded">

    <ng-container *ngIf="!selectionNotificationExpanded; else notificationRef">
        <div class="message"></div>
    </ng-container>
    <ng-template #notificationRef>

        <ng-container *ngIf="selectedRequests !== totalRequests && !isAllVisibleSelected">
            <div class="message">Selected ({{ selectedRequests }}) record(s).
                <ng-container *ngTemplateOutlet="selectVisibleRef"></ng-container>
                or
                <ng-container *ngTemplateOutlet="selectAllRef"></ng-container>
                or
                <ng-container *ngTemplateOutlet="cancelSelectionRef"></ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="selectedRequests !== totalRequests && isAllVisibleSelected">
            <div class="message">Selected ({{ selectedRequests }}) record(s).
                <ng-container *ngTemplateOutlet="selectAllRef"></ng-container>
                or
                <ng-container *ngTemplateOutlet="cancelSelectionRef"></ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="selectedRequests === totalRequests">
            <div class="message">Selected all ({{ totalRequests }}) record(s).
                <ng-container *ngTemplateOutlet="cancelSelectionRef"></ng-container>
            </div>
        </ng-container>

        <ng-template #selectVisibleRef>
            <span role="button" class="text-button"
                (click)="onSelectAllVisible.emit()">Select all available records on the page</span>
        </ng-template>

        <ng-template #selectAllRef>
            <span role="button" class="text-button" (click)="onSelectAll.emit()">Select all available records</span>
        </ng-template>

        <ng-template #cancelSelectionRef>
            <span role="button" class="text-button" (click)="onCancelSelection.emit()">Cancel selection</span>
        </ng-template>

    </ng-template>
</div>
